import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Checkbox from 'app/components/shared/Checkbox';
import './BatchActionsListItem.scss';

const srCheckboxLabel = (index, title) => (
  <ScreenReaderMessage>
    <FormattedMessage id="batch_actions_checkbox_details" values={{ index: index + 1, title }} />
  </ScreenReaderMessage>
);

export default function BatchActionsListItem({
  actionItem,
  updateItem,
  selectedItems,
  children,
  index,
  title,
  dataKey
}) {
  const id = actionItem.get('id');
  const selected = selectedItems.has(id);

  return (
    <div className="cp-batch-actions-list-item" data-key={dataKey}>
      <Checkbox
        checked={selected}
        dataKey={`batch-actions-list-item-checkbox-${id}`}
        handleChange={() => updateItem(actionItem)}
        id={`batch-actions-list-item-checkbox-${id}`}
        label={srCheckboxLabel(index, title)}
        value={id}
      />
      <div className="batch-actions-list-item-details">{children}</div>
    </div>
  );
}

BatchActionsListItem.propTypes = {
  actionItem: ImmutablePropTypes.map.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  updateItem: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  index: PropTypes.number.isRequired,
  title: PropTypes.string,
  dataKey: PropTypes.string.isRequired
};
